import { LOAD_REFERENCE_DATA, ReferenceDataActionTypes } from './Types';
import { GetLookupResponse } from '../../Services/ClientProxy/clientProxy';

export interface ReferenceDataState {
    taxpayersConfig?: GetLookupResponse;
}

const initialState: ReferenceDataState = {};

export function referenceDataReducer(
    state = initialState,
    action: ReferenceDataActionTypes
) {
    switch (action.type) {
        case LOAD_REFERENCE_DATA:
            return {
                ...state,
                taxpayersConfig: action.payload.taxPayersConfig,
            };
        default:
            return state;
    }
}
